import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { BaseService } from './base.service';
import { environment } from '../../environments/environment';

@Injectable()
export class EmployeeDataService extends BaseService {

    esbDataExpired: boolean;
    constructor(cookieService: CookieService,
                http: HttpClient) {
        super(cookieService, http);
        this.esbDataExpired = this.checkTimeStamp(localStorage.getItem('esbtimestamp'));
        if(this.esbDataExpired && !localStorage.getItem('esbExpired')){
            localStorage.setItem('esbExpired','1');
        }
    }

    getAllEmployees(): Observable<any> {
        const _employeeData = localStorage.getItem('employeeData');

        if( _employeeData &&
            _employeeData !== 'undefined' &&
            !this.esbDataExpired){
            let employeeData = JSON.parse(_employeeData);
            return of(employeeData).pipe(map(res => res));
        }

        let httpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.append('Content-Type', 'application/json');

        return this.http.get(
            EmployeeDataService.esbStaffGetUrl).pipe(
                map(log => log),
                tap(_ => this.log('Fetching employee data')),
                catchError(this.handleError('getLoginResponse')),
          );
    }

    getManagerByEmail(): Observable<any> {
        const _managerData = localStorage.getItem('managerData');

        if( _managerData && 
            _managerData !== 'undefined' &&
            !this.esbDataExpired){
            let mngrData = JSON.parse(_managerData);
            return of(mngrData).pipe(map(res => res));
        }

        let httpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.append('Accept', 'application/json');

        return this.http.get(
            EmployeeDataService.esbManagerGetUrl + '/' + this.managerKey.replace('@nearshoretechnology', '%40blueriver')).pipe(
                map(log => log),
                tap(_ => this.log('Fetching manager data for manager ' + this.managerKey.replace('@nearshoretechnology', '@blueriver'))),
                catchError(this.handleError('getLoginResponse')),
          );
    }

    checkTimeStamp(timestamp) {
        if(timestamp === null)
          return false;
        
        const days = environment.esb_check;  
        const firstDate = new Date(timestamp);
        const secondDate = new Date();
        const time = days * 60 * 60 * 24 * 1000;
    
        if ((secondDate.getTime() - firstDate.getTime()) < time) {
          //console.log({dateCheck: `Not greater than ${3} days`});
          return false;
        } else {
          //console.log({dateCheck: `Greater than ${3} days`});
          return true;
        }
      }
}
